const icon = require('vue-svgicon');
icon.register({
    'share': {
        width: 32,
        height: 32,
        viewBox: '0 0 32 32',
        data: `<path pid="0" d="M26.031 20.336c-1.857 0-3.484.881-4.551 2.236l-9.907-5.065c.129-.482.22-.981.22-1.507a5.64 5.64 0 00-.262-1.635l9.856-5.043c1.067 1.416 2.738 2.334 4.644 2.334a5.82 5.82 0 005.831-5.825 5.826 5.826 0 10-11.655 0c0 .526.093 1.025.22 1.507l-9.9 5.065c-1.067-1.351-2.701-2.234-4.559-2.234a5.831 5.831 0 000 11.662c1.906 0 3.577-.93 4.644-2.347l9.856 5.043c-.157.526-.27 1.069-.27 1.642A5.833 5.833 0 0026.029 32a5.833 5.833 0 000-11.664z"/>`,
    },
});
